import style from "./ProfiloUtente.module.css";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import InformazioniUtente from "./InformazioniUtente";
import AutorizzazioniUtente from "./AutorizzazioniUtente";
import { FC, useEffect, useState } from "react";
import { useAuth } from "../../providers/AuthProvider";

const menuItemsDefaultValue = [
  { label: "Informazioni", content: InformazioniUtente }
];
const menuItemsAdminValue = [
  { label: "Informazioni", content: InformazioniUtente },
  { label: "Autorizzazioni", content: AutorizzazioniUtente }
];

export default function ProfiloUtente() {
  const { user, grants } = useAuth();
  const [activeContent, setActiveContent] = useState<FC>(() => InformazioniUtente);
  const [items, setItems] = useState(menuItemsDefaultValue);

  const ActiveComponent = activeContent;

  useEffect(() => {
    console.log({grants});
    if (grants.includes("admin")) {
      setItems(menuItemsAdminValue);
    } else {
      setItems(menuItemsDefaultValue);
    }
  }, [user]);

  const handleClick = (content: FC) => {
    setActiveContent(() => content);
  };

  return (
      <div className={`container`}>
        <div className={style.profiloUtenteContainer}>
          <div className={style.sidebar}>
            <div className={style.userInfoContainer}>
              <AccountCircleIcon className={style.profileIcon} />
              <span className={style.title}>{user?.displayName}</span>
              <span className={style.subTitle}>
              {(user as any)?.role ? (user as any)?.role : "Operatore"}
            </span>
            </div>

            <ul className={style.menuList}>
              {items.map((item) => (
                  <li
                      key={item.label}
                      onClick={() => handleClick(item.content)}
                      className={style.listItem}
                  >
                    {item.label}
                  </li>
              ))}
            </ul>
          </div>

          <div className={style.details}>
            <ActiveComponent />
          </div>
        </div>
      </div>
  );
}
